import React, { useState } from 'react';
import { Card, CardHeader, CardTitle, CardContent } from './ui/card';
import { ChevronDown, ChevronUp } from 'lucide-react';

const AgentReport = () => {
  const [expandedId, setExpandedId] = useState(null);

  // Sample data - replace with actual data from your backend
  const reports = [
    {
      id: 1,
      customerName: "John Doe",
      propertyAddress: "123 Main St",
      inspectionDate: "2025-01-15",
      followUpScore: 85,
      conversationSummary: "Customer showed high interest. Main concerns were about pricing and renovation potential.",
      conversationHistory: [
        { timestamp: "2025-01-15 14:00", message: "Asked about property price" },
        { timestamp: "2025-01-15 14:05", message: "Discussed renovation possibilities" },
        { timestamp: "2025-01-15 14:10", message: "Inquired about neighborhood" }
      ]
    },
    // Add more report items as needed
  ];

  const getScoreColor = (score) => {
    if (score >= 80) return "text-green-600";
    if (score >= 60) return "text-yellow-600";
    return "text-red-600";
  };

  return (
    <div className="container mx-auto px-6 py-8">
      <h1 className="text-2xl font-bold mb-6">Inspection Reports</h1>
      <div className="space-y-4">
        {reports.map((report) => (
          <Card key={report.id} className="w-full">
            <CardHeader className="cursor-pointer" onClick={() => setExpandedId(expandedId === report.id ? null : report.id)}>
              <div className="flex justify-between items-center">
                <div>
                  <CardTitle className="text-xl">{report.customerName}</CardTitle>
                  <p className="text-gray-600">{report.propertyAddress}</p>
                </div>
                <div className="flex items-center gap-4">
                  <div className="text-center">
                    <p className="text-sm text-gray-600">Follow-up Score</p>
                    <p className={`font-bold ${getScoreColor(report.followUpScore)}`}>
                      {report.followUpScore}%
                    </p>
                  </div>
                  {expandedId === report.id ? <ChevronUp /> : <ChevronDown />}
                </div>
              </div>
            </CardHeader>
            {expandedId === report.id && (
              <CardContent>
                <div className="space-y-4">
                  <div>
                    <h3 className="font-semibold mb-2">Conversation Summary</h3>
                    <p className="text-gray-700">{report.conversationSummary}</p>
                  </div>
                  <div>
                    <h3 className="font-semibold mb-2">Conversation History</h3>
                    <div className="space-y-2">
                      {report.conversationHistory.map((item, index) => (
                        <div key={index} className="border-l-2 border-blue-200 pl-4">
                          <p className="text-sm text-gray-500">{item.timestamp}</p>
                          <p className="text-gray-700">{item.message}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </CardContent>
            )}
          </Card>
        ))}
      </div>
    </div>
  );
};

export default AgentReport;